import type { ReviewItem } from '@app/shared/types/sf-data'

export default function extractEndpointParams({
  ledgerId,
  reviewItems,
}: {
  ledgerId: number
  reviewItems: ReviewItem[]
}): {
  contextType: string
  contextId: number
  contextHrefParam: string | null
  ledgerId: number
} {
  const focusedIndex = reviewItems.findIndex((i) => i.focused) || 0
  const firstItem =
    reviewItems.length > 0 ? reviewItems[focusedIndex] : ({} as ReviewItem)

  return {
    contextType: firstItem.contextType,
    contextId: firstItem.contextId,
    contextHrefParam: firstItem.contextHrefParam,
    ledgerId,
  }
}
